import { initializeApp } from "firebase/app";
import { getAuth, setPersistence, browserLocalPersistence } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyBKk2BBGBX4LfVbTYjOJ0F4DCcNmwnKRrM",
  authDomain: "tradepowerapp.com",
  projectId: "skilltrade-app-2026",
  storageBucket: "skilltrade-app-2026.firebasestorage.app",
  messagingSenderId: "1029287610473",
  appId: "1:1029287610473:web:659e1021575f7c11103af8",
  measurementId: "G-7F1WJBQ535"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);

// Force local persistence for Safari/iOS compatibility
setPersistence(auth, browserLocalPersistence).catch(console.error);

export const db = getFirestore(app);
export const storage = getStorage(app);
export default app;